module.exports = __webpack_public_path__ + "img/shield.ffcbd28b.svg";